import makeRoot from "../../shared/containers/make_root";

import FilterBox from "../containers/filter_box";
import Breadcrumbs from "../containers/breadcrumbs";
import MainView from "../containers/main_view";

export default makeRoot(FilterBox, Breadcrumbs, MainView);
